<template>
  <card class="card-user">
    <div slot="image">
      <img src="" alt="" />
    </div>
    <div>
      <div class="author">
        <img class="avatar border-white" src="" alt="" />
        <h4 class="title">
          <br />
          <a href="#">
            <small></small>
          </a>
        </h4>
      </div>
      <p class="description text-center">

        <br />
        <br />
      </p>
    </div>
    <hr />
  </card>
</template>
<script>
export default {
  data() {
    // return {
    //   details: [
    //     {
    //       title: "12",
    //       subTitle: "Files",
    //     },
    //     {
    //       title: "2GB",
    //       subTitle: "Used",
    //     },
    //     {
    //       title: "24,6$",
    //       subTitle: "Spent",
    //     },
    //   ],
    // };
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-lg-3 offset-lg-1";
      } else if (remainder === 2) {
        return "col-lg-4";
      } else {
        return "col-lg-3";
      }
    },
  },
};
</script>
<style>
.card-user {
    margin-bottom: 30px;
    border-radius: 0.5rem;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.1);
}</style>
